module.exports = __webpack_public_path__ + "static/media/giftcard-newmom.441b82ff.jpg";